import Vue from 'vue'
export default new Vue({
    name: 'bus',
    data () {
        return {
        }
    }
})